import { t } from '@lingui/core/macro';
import { NoddiCard, NoddiSelectionCardGroup, type NoddiSelectionCardOption } from 'noddi-ui-web';
import type { OrganizationBookingAssignee as Assignee } from '../../../utils/organizationBookingAssignee';

type Props = {
  assignee: Assignee | null;
  selectedUserId: number | null;
  onSelect: (userId: number) => void;
};

export const OrganizationBookingAssignee = ({ assignee, selectedUserId, onSelect }: Props) => {
  if (assignee == null) {
    return null;
  }

  return (
    <NoddiCard>
      <fieldset className='m-0 flex min-w-0 flex-col gap-2 border-0 p-0'>
        <legend className='mb-2 text-lg leading-none font-semibold'>{t`Who is this booking for?`}</legend>
        <NoddiSelectionCardGroup
          size='small'
          options={assignee.choices.map(
            (choice): NoddiSelectionCardOption<number> => ({
              value: choice.userId,
              label: choice.name,
              description: choice.kind === 'driver' ? t`Driver` : t`You`,
              icon: 'User'
            })
          )}
          value={selectedUserId ?? undefined}
          onValueChange={onSelect}
        />
      </fieldset>
    </NoddiCard>
  );
};
